import {AppStore} from "../../desktop";
import {Category} from "../../models/Category";
import {CategoriesActionTypes} from "./types";
import {TabsActionTypes} from "../tabs";

export const actionCategoryFetchAll = () => {
	AppStore.dispatch({type: CategoriesActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionCategoryFetchAllCompleted = (categories: Category[]) => {
	AppStore.dispatch({type: CategoriesActionTypes.FETCH_ALL_COMPLETED, payload: categories})
}

export const actionCategoryFetch = (category: Category) => {
	AppStore.dispatch({type: CategoriesActionTypes.FETCH_ONE_REQUEST, payload: category})
}

export const actionCategoryFetchCompleted = (category: Category) => {
	AppStore.dispatch({type: CategoriesActionTypes.FETCH_ONE_COMPLETED, payload: category})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: category})
}

export const actionCategorySave = (category: Category) => {
	AppStore.dispatch({type: CategoriesActionTypes.SAVE_REQUEST, payload: category})
}

export const actionCategorySaveCompleted = (category: Category) => {
	AppStore.dispatch({type: CategoriesActionTypes.SAVE_COMPLETED, payload: category})
}

export const actionCategoryDelete = (category: Category) => {
	AppStore.dispatch({type: CategoriesActionTypes.DELETE_REQUEST, payload: category})
}

export const actionCategoryDeleteCompleted = (category: Category) => {
	AppStore.dispatch({type: CategoriesActionTypes.DELETE_COMPLETED, payload: category})
}

export const actionDeleteCategories = (categories: Category[]) => {
	AppStore.dispatch({type: CategoriesActionTypes.DELETE_MULTIPLE_REQUEST, payload: categories})
}

export const actionDeleteCategoriesCompleted = (categories: Category[]) => {
	AppStore.dispatch({type: CategoriesActionTypes.DELETE_MULTIPLE_COMPLETED, payload: categories})
}
